export default "__VITE_ASSET__f2a56ea7__"